module.exports = __webpack_public_path__ + "img/waxing-crescent.a5d6e245.svg";